import moment from 'moment';
import Vue from 'vue';
import { Backend } from '@/_axios';

// import { isMoment } from "moment";

// import mutations from './mutations'
// import actions from './actions'

export const LOAD_INCOMING_PAYMENTS = 'LOAD_INCOMING_PAYMENTS';
export const SET_INCOMING_PAYMENTS = 'SET_INCOMING_PAYMENTS';

export const CREATE_INCOMING_PAYMENT = 'CREATE_INCOMING_PAYMENT';
export const ADD_INCOMING_PAYMENT = 'ADD_INCOMING_PAYMENT';

export const DELETE_INCOMING_PAYMENT = 'DELETE_INCOMING_PAYMENT';
export const REMOVE_INCOMING_PAYMENT = 'REMOVE_INCOMING_PAYMENT';

export const EDIT_INCOMING_PAYMENT = 'EDIT_INCOMING_PAYMENT';
export const UPDATE_INCOMING_PAYMENT = 'UPDATE_INCOMING_PAYMENT';

export const INCOMING_PAYMENTS_ERROR_MESSAGES = 'INCOMING_PAYMENTS_ERROR_MESSAGES';

const state = {
  incomingPayments: {},
  incomingPaymentNotification: {
    data: {},
    status: 'loading',
    message: '',
  }
};

const getters = {
  incomingPayments: (state) => {
    return state.incomingPayments;
  },
  incomingPaymentNotification: (state) => {
    return state.incomingPaymentNotification;
  },
  plannedIncomingPaymentsByProjectByYearweek: (state) => {
    const payments = {};
    for (const paymentId in state.incomingPayments) {
      const payment = state.incomingPayments[paymentId];
      if (payment.type == 'planned') {
        if (!payments[payment.project_id]) payments[payment.project_id] = {};

        const overdue = new Date() > new Date(payment.expected_on);
        if (overdue) payment.expected_on = moment().format('YYYY-MM-DD');

        const yearweek = moment(payment.expected_on).format('GGGGWW');
        if (!payments[payment.project_id][yearweek]) {
          payments[payment.project_id][yearweek] = {
            planned: 0,
            overdue: 0
          };
        }

        if (overdue) {
          payments[payment.project_id][yearweek].overdue += payment.amount;
        } else {
          payments[payment.project_id][yearweek].planned += payment.amount;
        }
      }
    }
    return payments;
  },
  plannedIncomingPaymentsByYearweek: (state) => {
    const payments = {};
    for (const paymentId in state.incomingPayments) {
      const payment = state.incomingPayments[paymentId];
      if (payment.type = 'planned') {
        let date = payment.expected_on;
        const overdue = new Date() > new Date(payment.expected_on);
        if (overdue) date = moment().format('YYYY-MM-DD');

        const yearweek = moment(date).format('GGGGWW');
        if (!payments[yearweek]) {
          payments[yearweek] = {
            planned: 0,
            overdue: 0
          };
        }

        if (overdue) {
          payments[yearweek].overdue += payment.amount;
        } else {
          payments[yearweek].planned += payment.amount;
        }
      }
    }
    return payments;
  },
};

const actions = {
  [LOAD_INCOMING_PAYMENTS]: function ({ commit }) {
    Backend.get('/api/incoming-payments').then((response) => {
      const incomingPayments = {};
      response.data.forEach((incomingPayment) => {
        incomingPayments[incomingPayment.id] = incomingPayment;
        incomingPayments[incomingPayment.id].amount /= 100;
        incomingPayments[incomingPayment.id].prepayment /= 100;
        incomingPayments[incomingPayment.id].toBePaid = incomingPayments[incomingPayment.id].amount + incomingPayments[incomingPayment.id].prepayment;
      });
      commit('SET_INCOMING_PAYMENTS', { incomingPayments: incomingPayments });
    });
  },
  [CREATE_INCOMING_PAYMENT]: function ({ commit }, { expected_on, contractual_invoice_date, forecasted_invoice_date, project_id, amount, prepayment, description, incoming, type }) {
    Backend.post('/api/new-incoming-payment', { expected_on: expected_on, contractual_invoice_date: contractual_invoice_date, forecasted_invoice_date: forecasted_invoice_date, project_id: project_id, amount: amount, prepayment: prepayment, description: description, incoming: incoming, type: type }).then((response) => {
      commit('ADD_INCOMING_PAYMENT', { incomingPayment: response.data.data.data, message: response.data.data.message });
    }, (err) => {
      console.log(err.response);
      commit('INCOMING_PAYMENTS_ERROR_MESSAGES', { messages: err.response.data.messages });
    });
  },
  [DELETE_INCOMING_PAYMENT]: function ({ commit }, id) {
    Backend.delete('/api/delete-incoming-payment', { params: { id: id } }).then((response) => {
      commit('REMOVE_INCOMING_PAYMENT', { data: response.data.data.data, message: response.data.data.message });
    }, (err) => {
      console.log(err.response);
      commit('INCOMING_PAYMENTS_ERROR_MESSAGES', { messages: err.response.data.messages });
    });
  },
  [EDIT_INCOMING_PAYMENT]: function ({ commit }, { id, expected_on, contractual_invoice_date, forecasted_invoice_date, project_id, amount, prepayment, description, type }) {
    Backend.post('/api/edit-incoming-payment', { id: id, expected_on: expected_on, contractual_invoice_date: contractual_invoice_date, forecasted_invoice_date: forecasted_invoice_date, project_id: project_id, amount: amount, prepayment: prepayment, description: description, type: type }).then((response) => {
      commit('UPDATE_INCOMING_PAYMENT', { incomingPayment: response.data.data.data, message: response.data.data.message });
    }, (err) => {
      console.log(err.response);
      commit('INCOMING_PAYMENTS_ERROR_MESSAGES', { messages: err.response.data.messages });
    });
  },
};

const mutations = {
  [SET_INCOMING_PAYMENTS]: function (state, { incomingPayments }) {
    Vue.set(state, 'incomingPayments', incomingPayments);
  },
  [ADD_INCOMING_PAYMENT]: function (state, { incomingPayment, message }) {
    incomingPayment.amount /= 100;
    incomingPayment.prepayment /= 100;
    incomingPayment.toBePaid = incomingPayment.amount + incomingPayment.prepayment;
    Vue.set(state.incomingPayments, incomingPayment.id, incomingPayment);
    state.incomingPaymentNotification = {
      status: 'success',
      data: incomingPayment,
      message: message

    };
  },
  [REMOVE_INCOMING_PAYMENT]: function (state, { data, message }) {
    Vue.delete(state.incomingPayments, data.id);
    state.incomingPaymentNotification = {
      status: 'success',
      data: data,
      message: message
    };
  },
  [UPDATE_INCOMING_PAYMENT]: function (state, { incomingPayment, message }) {
    incomingPayment.amount /= 100;
    incomingPayment.prepayment /= 100;
    incomingPayment.toBePaid = incomingPayment.amount + incomingPayment.prepayment;
    Vue.set(state.incomingPayments, incomingPayment.id, incomingPayment);
    state.incomingPaymentNotification = {
      status: 'success',
      data: incomingPayment,
      message: message
    };
  },
  [INCOMING_PAYMENTS_ERROR_MESSAGES]: function (state, { messages }) {
    state.incomingPaymentNotification = {
      status: 'error',
      data: {},
      message: messages
    };
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
